import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

/* export interface Sklop {
  value: string;
  viewValue: string;
} */

/* export interface Spremenljivka {
  value: string;
  viewValue: string;
} */

export interface Sezona {
  value: string;
  viewValue: string;
}

export interface Scenarij {
  value: string;
  viewValue: string;
}

export interface IzjemnePadavine {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-filter4',
  templateUrl: './filter4.component.html',
  styleUrls: ['./filter4.component.css']
})
export class Filter4Component implements OnInit {

  name:string;

  selected1 = undefined;
  selected2 = undefined;
  selected3 = undefined;
  selected4 = undefined;
  selected5 = undefined;

  public izbira = [
    {value: 1, viewValue: 'Padavine'},
    {value: 2, viewValue: 'Sončno obsevanje'},
    {value: 3, viewValue: 'Veter'},
    {value: 4, viewValue: 'Vodna bilanca'}
  ];

  defualtOption = null;
  public spremenljivka = [];

  /* spremenljivka: Spremenljivka[] = [
    {value: 'spr-6', viewValue: 'Izjemne padavine'},
    {value: 'spr-10', viewValue: 'Vodni primanjkljaj'}
  ]; */

  izjemnePadavine: IzjemnePadavine[] = [
    {value: 'izjemnePadavine-0', viewValue: 'Največja enodnevna višina padavin'},
    {value: 'izjemnePadavine-1', viewValue: 'Največja tridnevna višina padavin'},
    {value: 'izjemnePadavine-2', viewValue: 'Največja petdnevna višina padavin'}
  ];

  sezona: Sezona[] = [
    {value: 'sezona-0', viewValue: 'Leto'},
    {value: 'sezona-1', viewValue: 'Zima'},
    {value: 'sezona-2', viewValue: 'Pomlad'},
    {value: 'sezona-3', viewValue: 'Poletje'},
    {value: 'sezona-4', viewValue: 'Jesen'},
  ];

  scenarij: Scenarij[] = [
    {value: 'scenarij-0', viewValue: 'RCP2.6'},
    {value: 'scenarij-1', viewValue: 'RCP4.5'},
    {value: 'scenarij-2', viewValue: 'RCP8.5'}
  ];


  selectDisabled3 = true;
  selectDisabled4 = true;
  selectDisabled5 = true;
  hidden3 = false;
  hidden4 = false;
  hidden5 = false;

  firstDropDownChanged(viewValue: any) {
    const obj = this.izbira[viewValue];
    console.log(obj);
    
    this.selected2 = undefined;
    this.selected3 = undefined;
    this.selected4 = undefined;
    this.selected5 = undefined;

    if (!obj) return;
    
    if (obj.value == 1) {
      this.spremenljivka = [
        {value: 'spr-6', viewValue: 'Izjemne padavine'}
      ];
      this.selectDisabled3 = false;
      this.selectDisabled4 = false;
      this.selectDisabled5 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;

    }
    else if (obj.value == 4) {
      this.spremenljivka = [
        {value: 'spr-10', viewValue: 'Vodni primanjkljaj'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
    }
    else if (obj.value == 3) {
      this.spremenljivka = [
        {value: 'spr-31', viewValue: 'Povprečna hitrost vetra'},
        {value: 'spr-32', viewValue: 'Največja hitrost vetra'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;
    }
    else {
      this.spremenljivka = [
        {value: 'spr-21', viewValue: 'Globalni obsev'},
        {value: 'spr-22', viewValue: 'Trajanje sončnega obsevanja'}
      ];
      this.selectDisabled3 = true;
      this.selectDisabled4 = false;
      this.selectDisabled5 = false;
      this.hidden3 = false;
      this.hidden4 = false;
      this.hidden5 = false;

    }

    this.eventClicked1.emit(this.selected1);
    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked4.emit(this.selected4);
    this.eventClicked5.emit(this.selected5);

  }

  secondDropDownChanged(value: any) {
    console.log(value);

    if (value == 'spr-6') {
      this.hidden3 = true;
      this.hidden4 = true;
      this.hidden5 = true;
      this.izjemnePadavine = this.izjemnePadavine;
    }

    else {
      this.hidden3 = false;
      this.hidden4 = true;
      this.hidden5 = true;
      this.selected3 = undefined;
    }

    this.eventClicked2.emit(this.selected2);
    this.eventClicked3.emit(this.selected3);
    this.eventClicked4.emit(this.selected4);

  }

  thirdDropDownChanged(value: any) {
    console.log(value);
  }

  fourthDropDownChanged(value: any) {
    console.log(value);
  } 

  fifthDropDownChanged(value: any) {
    console.log(value);
  }

  @Output() eventClicked1 = new EventEmitter<Event>();
  @Output() eventClicked2 = new EventEmitter<Event>();
  @Output() eventClicked3 = new EventEmitter<Event>();
  @Output() eventClicked4 = new EventEmitter<Event>();
  @Output() eventClicked5 = new EventEmitter<Event>();

  constructor(private router: Router,
    private route: ActivatedRoute) { }

  ngOnInit() {
  }

  onClick1(selected1: Event): void {
    this.eventClicked1.emit(selected1);
  }

  onClick2(selected2: Event): void {
    this.eventClicked2.emit(selected2);
  }

  onClick3(selected3: Event): void {
    this.eventClicked3.emit(selected3);
  }

  onClick4(selected4: Event): void {
    this.eventClicked4.emit(selected4);
  }

  onClick5(selected5: Event): void {
    this.eventClicked5.emit(selected5);
  }

}
